export const workingHours = 168;
export const minRateUs = 35;
export const maxRateUs = 65;
export const minRateMena = 30;
export const maxRateMena = 60;
export const minRateGb = 40;
export const maxRateGb = 70;
export const minRateDach = 40;
export const maxRateDach = 70;
export const minRateEu = 35;
export const maxRateEu = 60;
